import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import IndexList from '../../../lib/ui/IndexControl'
import EducationForm from '../ui/EducationForm'
import LogentryModel from '../../logentry/model/LogentryModel'
import PersonModel from '../../person/model/PersonModel'
import EducationModel from '../model/EducationModel'
import ObjectTypeMapping from '../../constants/ObjectTypeMapping'

export default class EditEducation {
  constructor (element, args) {
    this.onchange = () => {
      this.data = this.educationForm.getValue()

      window.PRIM.initDelayedNavigation()
      window.PRIM.dataAccess.put('educations', this.data.getJSON()).then((education) => {
        if (!window.PRIM.isDelayedNavigationActive())
        {
          return
        }

        if (args && !args.id && education.id) {
          window.PRIM.navigate('/educations/' + education.id, true)
        }

        if (education) {
          this.data.values.id = education.id
          this.educationForm.setValue(this.data)
        }        
      })
    }

    if (args) {
      if (args.id) {
        window.PRIM.dataAccess.resolve('educations', args.id, true).then((education) => {
          this.data = education
          this.educationForm.setValue(this.data)

          window.PRIM.dataAccess.get('logentries').then((logentries) => {
            let results = logentries.filter((logentry) => {
              return logentry.target_id === this.data.values.id && logentry.object_type_id === ObjectTypeMapping.education
            })

            this.data.logentries = results.map((logentry) => {
              return new LogentryModel(logentry)
            })

            this.logIndex.setItems(this.data.logentries)
          }, () => {
          }).catch(() => {
          })
        }, () => {
          if (confirm('Deze opleiding bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe functie aanmaken?')) {
            window.PRIM.navigate('/educations/')
          } else {
            history.back()
          }
        }).catch(() => {
        })
      } else if (args.person_id) {
        window.PRIM.dataAccess.resolve('people', args.person_id, true).then((person) => {
          this.data = new PersonModel()
          this.data.values.person_id = person.values.id
          this.data.person = person
          this.educationForm.setValue(this.data)
        })
      }
    }

    this.data = new EducationModel()

    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Opleiding bewerken',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/start/')
          },
          icon: '\ue08a'
        },
        {
          onclick: this.onchange,
          icon: '\ue020',
          classes: 'indicator'
        }],
      contextMenu: [
        {
          onclick: () => {
            if (this.data.values.id) {
              window.PRIM.navigate('/logentries/education/' + this.data.values.id)
            } else {
              alert('Vul eerst gegevens voor deze opleiding.')
            }
          },
          icon: '\ue032',
          label: 'Logboekregel'
        },
        {
          onclick: () => {
            if (this.data.values.id) {
              if (confirm('Weet u het zeker dat u deze opleiding wilt verwijderen?')) {
                window.PRIM.dataAccess.delete('educations', this.data.values.id).then(() => {
                  history.back()
                })
              }
            } else {
              alert('Vul eerst gegevens voor deze opleiding.')
            }
          },
          icon: '\ue123',
          label: 'Verwijderen'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let divContent = document.createElement('div')
    divContent.className = 'content'

    let primaryData = document.createElement('section')
    primaryData.className = 'primary'
    let secondaryData = document.createElement('section')
    secondaryData.className = 'secondary'

    this.educationForm = new EducationForm(primaryData, {education: this.data, onchange: this.onchange})

    let fieldsetLog = document.createElement('fieldset')
    let legendLog = document.createElement('legend')
    legendLog.innerHTML = 'Logboek'
    fieldsetLog.appendChild(legendLog)

    let onclickLogentry = (item) => {
      window.PRIM.navigate('/logentries/' + item.values.id)
    }

    this.logIndex = new IndexList(fieldsetLog, {items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry})

    secondaryData.appendChild(fieldsetLog)

    divContent.appendChild(primaryData)
    divContent.appendChild(secondaryData)
    div.appendChild(divContent)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/education/action/EditEducation.js